import dayjs from 'dayjs';
import _ from 'lodash';
import { useState, useCallback } from 'react';

import { isWordReadyToExercise } from 'core/helpers/exercise';

const sortByDate = (a: TWord, b: TWord): number => {
  const dateA = a.status.wordCards?.nextProbeAt;
  const dateB = b.status.wordCards?.nextProbeAt;
  if (!dateA || !dateB) return !dateA ? -1 : +1;

  return dayjs.utc(dateA).isBefore(dateB) ? -1 : +1;
};

export default function useWordsList(exercise: TExercise, wordUid?: string) {
  const [words, setWords] = useState<TWord[] | null>(null);

  const setter = useCallback((source: TWord[] | null) => {
    if (!source) {
      setWords(null); // reset
      return;
    }

    const words = source
      .filter(word => (wordUid ? word : isWordReadyToExercise(word, exercise)))
      .sort(sortByDate);
    setWords(_.shuffle(words));
  }, []);

  const onUpdateWord = useCallback((updateWord: TWord): void => {
    setWords(words =>
      orDie(words).map(word =>
        updateWord.uid === word.uid ? updateWord : word
      )
    );
  }, []);

  return [words, setter, onUpdateWord] as const;
}
